import {useEffect} from 'react';
import {useRouteKey} from '@/hooks/use-route-key';
import i18n from '@/initializers/i18next';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {WebPageViewEvent} from '@/services/analytics/analytics-types';

const FORM_ROUTE = '/app/form/';

export const useNonFormPageViewEvent = (
  userUniqueId: WebPageViewEvent['context']['user_unique_id'],
  userRole: WebPageViewEvent['context']['user_role'],
) => {
  const {pathname, routeKey} = useRouteKey();

  useEffect(() => {
    // Skip tracking if current route is form, which uses `useFormPageViewEvent`
    if (pathname.startsWith(FORM_ROUTE)) {
      return;
    }

    analyticsHandler.webPageView({
      page_name: routeKey,
      page_language: i18n.language as 'fr' | 'en',
      funnel_step: null,
      user_unique_id: userUniqueId,
      user_role: userRole,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when pathname changes
  }, [pathname]);
};
